/**
 * HTML-string builders kept API-compatible with the legacy
 * `public/assets/js/shared/vivDesignSystem.js` IIFE. They now live in TS next to
 * the web components and share the same class names / token-based styling, so
 * innerHTML-driven call sites (editor monolith) can migrate incrementally.
 */
import { escapeHtml } from '../core/htmlEscape.js';

export const CLASS = {
    searchResults: 'vivDs-searchResults',
    searchResult: 'vivDs-searchResult',
    searchResultSelected: 'vivDs-searchResult--selected',
    chipList: 'vivDs-chipList',
    chip: 'vivDs-chip',
    chipRemove: 'vivDs-chipRemove',
} as const;

export function cssClasses(): string[] {
    return Object.values(CLASS);
}

export function buildSearchResultsEmpty(message: string): string {
    return `<p class="settingsDescription vivDs-searchResultsEmpty">${escapeHtml(message)}</p>`;
}

export interface SearchResultConfig {
    label?: string;
    value?: string;
    selected?: boolean;
    onclick?: string;
    dataAttrName?: string;
    dataAttrValue?: string | number | null;
}

export function buildSearchResultButton(config: SearchResultConfig = {}): string {
    const selected = config.selected === true;
    const name = escapeHtml(config.label || '');
    const onclick = config.onclick ? ` onclick="${config.onclick}"` : '';
    const dataAttr = config.dataAttrName && config.dataAttrValue != null
        ? ` data-${escapeHtml(config.dataAttrName)}="${escapeHtml(config.dataAttrValue)}"`
        : '';
    return `<button type="button" class="${CLASS.searchResult}${selected ? ' ' + CLASS.searchResultSelected : ''}"${dataAttr}${onclick}>
            <i class="fas ${selected ? 'fa-check-square' : 'fa-square'}" aria-hidden="true"></i>
            <span>${name}</span>
        </button>`;
}

export interface ChipConfig {
    label?: string;
    onclick?: string;
    title?: string;
}

export function buildChip(config: ChipConfig = {}): string {
    const label = escapeHtml(config.label || '');
    const onclick = config.onclick ? ` onclick="${config.onclick}"` : '';
    const title = config.title ? ` title="${escapeHtml(config.title)}"` : '';
    return `<button type="button" class="${CLASS.chip}"${title}${onclick}>
            <span>${label}</span>
            <i class="fas fa-times ${CLASS.chipRemove}" aria-hidden="true"></i>
        </button>`;
}
